import {
    Popconfirm,
    Table,
    Tooltip,
    notification, Image
} from "antd";
import {ColumnsType} from "antd/es/table";
import React, {useEffect, useState} from "react";
import {Button, Card, Col, Row} from "react-bootstrap";
import {Icon} from "ts-react-feather-icons";
import {ActionType} from "../../constants/actionType";
import {UserRole} from "../../constants/userRole";
import {useUser} from "../../hooks";
import User from "../../model/User";
import CustomPagination from "../CustomPagination";
import {deleteCharacterOutfit, getCharacterOutfitDetail, getCharacterOutfits} from "../../helpers/api/character";
import OutfitDrawer from "./OutfitDrawer";
import {Link} from "react-router-dom";

interface CharacterOutfitModel {
    key: React.Key;
    id: string;
    characterId: string;
    name: string;
    imageUrl: string;
    createdBy: string;
    modifiedBy: string;
    createdAt: Date;
    modifiedAt: Date;
}

const CharacterOutfitTable = ({
                                  character
                              }: any) => {

    const [pageSize, setPageSize] = useState<number>(10);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [totalRecord, setTotalRecord] = useState<number>(0);
    const [outfits, setOutfits] = useState<any[]>([]);
    const [outfitDetail, setOutfitDetail] = useState<any>(null);
    const [actionType, setActionType] = useState<string>("");
    const [outfitDrawerVisibility, setOutfitDrawerVisibility] = useState<boolean>(false);

    const currentLoggedInUser = useUser().user as User || null;
    const [api, contextHolder] = notification.useNotification();

    const [searchLoading, setSearchLoading] = useState<boolean>(false);

    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }

    const columns: ColumnsType<CharacterOutfitModel> = [
        {
            title: "No.",
            dataIndex: "noNumber"
        },
        {
            title: "Name",
            dataIndex: "name",
            render: (text, record, index) => {
                return (
                    <Link to={`/characters/${character.id}/outfits/${record.id}`}>
                    <span>
                        {record.name}
                    </span>
                    </Link>
                )
            },
        },
        {
            title: "Preview",
            dataIndex: "imageUrl",
            render: (text, record, index) => {
                return (
                    <Image
                        width={50}
                        src={record.imageUrl}
                    />

                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (text, record, index) => {
                return (
                    (currentLoggedInUser?.roles?.includes(UserRole.SUPER_ADMIN) || currentLoggedInUser?.roles?.includes(UserRole.ADMIN)) && (
                        <>
                            <Tooltip title="Update">
                                <span role="button"
                                      onClick={() => triggerUpdate(record.characterId, record.id)}
                                      className="d-inline-block ms-1"
                                >
                                    <Icon name="edit-2" color="#0d6efd" size={16}/>
                                </span>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <Popconfirm
                                    title={`Delete outfits`}
                                    description={`Are you sure to delete this outfit?`}
                                    onConfirm={() => triggerDeleteOutfit(record)}
                                    okText="OK"
                                    cancelText="Cancel"
                                >
                                    <span role="button" className="d-inline-block ms-1">
                                        <Icon name="trash-2" color="#dc3545" size={16}/>
                                    </span>
                                </Popconfirm>
                            </Tooltip>
                        </>
                    )
                );
            },
        },
    ];

    useEffect(() => {
        if (!character) {
            return;
        }
        search();
    }, [pageIndex]);

    useEffect(() => {
        if (!character) {
            return;
        }
        if (pageIndex === 1) {
            search();
            return;
        }
        setPageIndex(1);
    }, [pageSize]);

    const search = async () => {
        setSearchLoading(true);
        const searchObj: any = {
            pageIndex: pageIndex - 1,
            pageSize,
        };
        try {
            const response = await getCharacterOutfits(character.id, searchObj);
            if (response.status === 200) {
                const data: any[] = [];
                response.data.data.forEach((item: any, index: number) => {
                    data.push({
                        ...item,
                        noNumber: (pageIndex - 1) * pageSize + index + 1,
                    });
                });
                setOutfits(data);
                setTotalRecord(response.data.totalRecord);
            }
        } catch (err) {
            console.error(err);
            api.error({
                message: `Error notification`,
                description: <span className="text-danger">{err as string || 'There\'re some errors occured!'}</span>,
                placement: 'topRight'
            });
        }
        setSearchLoading(false);
    }

    const triggerUpdate = async (characterId: string, outfitId: string) => {
        try {
            if (!outfitId || outfitId?.trim()?.length === 0) {
                return;
            }
            const outfit = await getCharacterOutfitDetail(characterId, outfitId);
            setOutfitDetail(outfit.data.data);
            setActionType(ActionType.UPDATE);
            setOutfitDrawerVisibility(true);
        } catch (err) {
            console.error(err);
            showError(err as string);
        }
    }

    const triggerDeleteOutfit = async (outfit: CharacterOutfitModel) => {
        try {
            if (!outfit || !outfit?.id) {
                return;
            }
            await deleteCharacterOutfit(character.id, outfit.id);
        } catch (err) {
            console.error(err);
            showError(err as string);
        }
        await search();
    }

    return (
        <>
            {contextHolder}

            <OutfitDrawer
                character={character}
                drawerVisibility={outfitDrawerVisibility}
                setdDrawerVisibility={setOutfitDrawerVisibility}
                outfitDetail={outfitDetail}
                setOutfitDetail={setOutfitDetail}
                actionType={actionType}
                setActionType={setActionType}
                onSuccess={() => {
                    api.success({
                        message: `Successfull notification`,
                        description: (actionType === ActionType.CREATE ? "Create" : "Update") + ' outfit successfully!',
                        placement: 'topRight'
                    });
                    setOutfitDetail(null);
                    setActionType("");
                    search();
                }}
                onFailure={(errorMessage: string) => {
                    showError(errorMessage);
                }}
            />


            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col sm={6} className="mb-2">
                                    <span className="fw-bold lead text-success">OUTFITS</span>
                                </Col>
                                <Col sm={6} className="mb-2">
                                    <div className="text-sm-end">
                                        <Button variant="success" className="mb-1 py-1 me-1" onClick={() => {
                                            search();
                                        }}>
                                            <i className="mdi mdi-refresh me-1"></i> Refresh
                                        </Button>
                                        <Button variant="primary" className="mb-1 py-1 me-1" onClick={() => {
                                            setActionType(ActionType.CREATE);
                                            setOutfitDrawerVisibility(true);
                                        }}>
                                            <i className="mdi mdi-plus-circle me-1"></i> Create
                                        </Button>
                                    </div>
                                </Col>
                            </Row>

                            <Table
                                loading={searchLoading}
                                rowKey={"noNumber"}
                                className="table table-hover m-0 table-centered dt-responsive nowrap w-100"
                                dataSource={outfits}
                                columns={columns}
                                pagination={false}
                            />

                            {outfits?.length !== 0 && (
                                <CustomPagination
                                    pageIndex={pageIndex}
                                    pageSize={pageSize}
                                    totalItem={totalRecord}
                                    setPageSize={setPageSize}
                                    setPageIndex={setPageIndex}
                                />
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default CharacterOutfitTable;
